export default __webpack_public_path__ + "static/media/codarludo.59c3c32b.png";